import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { btnSx } from "../components/ActionDrawer";
import { Board, Empty, Notice, PageHead } from "../components/DashTable";
import PageLoader from "../components/Loader";
import { useToast } from "../components/Toast";
import apiService from "../Services/api.service";

const inr = (n) =>
  n === null || n === undefined || n === ""
    ? "—"
    : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

/* SL5. All specialists, every live order, grouped by stage. */
const TeamPipeline = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const token = localStorage.getItem("token");

  const [stages, setStages] = useState([]);
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  const fetchRows = async () => {
    setIsLoading(true);
    setLoadFailed(false);
    try {
      const res = await apiService.fetchPipeline(token);
      setStages(res.data || []);
      setSummary(res.summary || null);
    } catch (error) {
      setLoadFailed(true);
      toast.error("Error while fetching the pipeline");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = stages.map((stage) => ({
    title: stage.stage,
    value: inr(stage.value),
    cards: (stage.orders || []).map((o) => ({
      id: o.orderId,
      ref: o.orderNumber,
      title: o.doctorName,
      meta: `${inr(o.orderTotal)} · ${o.ageDays ?? 0}d${o.held ? " · held" : ""}`,
    })),
  }));

  const kpis = summary
    ? [
        { label: "Live orders", value: summary.liveOrders },
        { label: "Stalled", value: summary.stalled, alarm: true },
        { label: "Pipeline value", value: inr(summary.pipelineValue) },
        { label: "Specialists", value: summary.specialists },
      ]
    : [];

  return (
    <Box sx={{ padding: { xs: "18px 16px 50px", md: "24px 28px 60px" }, maxWidth: 1240 }}>
      <PageHead
        title="Team pipeline"
        lede="All orders across every specialist. Read-only except the agreement gate."
        kpis={kpis}
      />

      {loadFailed ? (
        <Empty
          title="Could not load the pipeline"
          sub={
            <Box
              component="button"
              type="button"
              onClick={fetchRows}
              sx={{ ...btnSx("ghost"), margin: "12px auto 0", display: "block" }}
            >
              Retry
            </Box>
          }
        />
      ) : columns.length === 0 && !isLoading ? (
        <Empty title="No live orders" sub="Orders appear here once created." />
      ) : (
        <Board
          columns={columns}
          onCardClick={(id) => navigate(`/dashboard/orders/${id}`)}
        />
      )}

      <Notice>
        <b>Gate owners differ by column.</b> Quotation and advance payment sit
        with the specialist, the agreement with you, pre-dispatch with the Ops
        Associate, and installation with the Ops Lead.
      </Notice>

      {isLoading && <PageLoader />}
    </Box>
  );
};

export default TeamPipeline;
